import { tWithKeyAttr as t } from "../../i18nHelper";
import React, { useState } from "react";
import styles from "./companyImpersonationNotice.module.css";
import Tooltip from "../tooltip/tooltip";
import useMediaQuery from "../../hooks/useMediaQuery";
import { mobileWidth } from "../../utils/constants";

type CompanyImpersonationNoticeProps = {
  name: string;
  position: { top: number; left: number };
  onDragEnd: (top: number, left: number) => void;
};

const CompanyImpersonationNotice: React.FC<CompanyImpersonationNoticeProps> = ({
  name,
  position,
  onDragEnd,
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [showTooltip, setShowTooltip] = useState(false);
  const mobile = useMediaQuery(mobileWidth);

  const handleDragStart = (e: React.DragEvent<HTMLDivElement>) => {
    setIsDragging(true);
    setOffset({
      x: e.clientX - position.left,
      y: e.clientY - position.top,
    });
    e.dataTransfer.effectAllowed = "move";
  };
  const handleDragEnd = (ev: React.DragEvent<HTMLDivElement>) => {
    setIsDragging(false);
    const newTop = ev.clientY - offset.y;
    const newLeft = ev.clientX - offset.x;
    onDragEnd(newTop, newLeft);
  };

  return (
    <div
      className={`${styles.notice} 
  ${styles.fixedPosition} ${isDragging ? styles.dragging : ""}`}
      draggable
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      style={
        mobile
          ? { bottom: position.top, left: position.left, top: "auto" }
          : { top: position.top, left: position.left, bottom: "auto" }
      }
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <Tooltip isShown={showTooltip} position="bottom">
        {t("DRAGGABLE")}
      </Tooltip>
      {t("YOU_VIEW_IN_COMPANY", { companyName: name })}{" "}
    </div>
  );
};

export default CompanyImpersonationNotice;
